import type { LabelHTMLAttributes, ReactNode } from 'react'
import { cn } from '../../lib/utils'

type FieldLabelProps = LabelHTMLAttributes<HTMLLabelElement> & {
  required?: boolean
  optional?: boolean
  children: ReactNode
}

export function RequiredMark() {
  return (
    <span className="ml-0.5 text-danger" aria-hidden="true">
      *
    </span>
  )
}

export function FormRequiredLegend({ className }: { className?: string }) {
  return (
    <p className={cn('text-xs text-ink-500', className)}>
      Fields marked with <span className="text-danger">*</span> are required.
    </p>
  )
}

export function FieldLabel({
  required = false,
  optional = false,
  children,
  className,
  ...props
}: FieldLabelProps) {
  return (
    <label className={cn('field-label', className)} {...props}>
      {children}
      {required && <RequiredMark />}
      {optional && <span className="ml-1 font-normal text-ink-500">(optional)</span>}
      {required && <span className="sr-only"> (required)</span>}
    </label>
  )
}
